class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onQuickAddClick = (event) => {
      const trigger = event.target.closest('[data-chase-cart-recommendations] [data-chase-quick-add], [data-chase-cart-recommendations] modal-opener button');
      if (trigger) this.close();
    };
    this.addEventListener('click', this.onQuickAddClick);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.loadRecommendations(parsedState.product_id || parsedState.items?.[0]?.product_id);
    if (this.header) this.header.reveal();
    this.open();
  }

  async loadRecommendations(productId) {
    const container = this.querySelector('[data-chase-cart-recommendations]');
    if (!container) return;
    this.recommendationsController?.abort();
    container.hidden = true;
    container.replaceChildren();
    document.querySelectorAll('quick-add-modal[id^="QuickAdd-ChaseCartRecommendations-"]').forEach((modal) => modal.remove());
    if (!productId) return;
    const controller = new AbortController();
    this.recommendationsController = controller;
    const url = new URL(container.dataset.url, window.location.origin);
    url.searchParams.set('product_id', String(productId));
    container.dataset.productId = String(productId);
    container.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url.href, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = html.querySelector('[data-chase-cart-recommendations-content]');
      if (controller.signal.aborted || !content?.querySelector('.card-wrapper')) return;
      container.replaceChildren(...content.childNodes);
      container.hidden = false;
      const slider = container.querySelector('slider-component');
      if (slider?.initPages) requestAnimationFrame(() => slider.isConnected && slider.initPages());
    } catch (error) {
      if (error.name !== 'AbortError') container.hidden = true;
    } finally {
      if (this.recommendationsController === controller) container.removeAttribute('aria-busy');
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onQuickAddClick);
    this.recommendationsController?.abort();
    document.body.removeEventListener('click', this.onBodyClick);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  
}

customElements.define('cart-notification', CartNotification);
